import React from 'react'
import { useAgTechTour } from './AgTechTourContext'
import AgTechTourOverlay from './AgTechTourOverlay'
import AgTechTourCallout from './AgTechTourCallout'

const AgTechTourSurface = () => {
    const { isActive, currentStep, currentStepIndex, config } = useAgTechTour()

    if (!isActive || !currentStep || !config) return null

    return (
        <>
            <AgTechTourOverlay step={currentStep} />
            <AgTechTourCallout step={currentStep} stepIndex={currentStepIndex} totalSteps={config.steps.length} />
        </>
    )
}

export default AgTechTourSurface
